import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormOrderExchangeComponent } from './form.component';
import { FieldsModule } from '../../fields/fields.module';

@NgModule({
  declarations: [
    FormOrderExchangeComponent
  ],
  imports: [
    CommonModule,
    FieldsModule
  ], exports:[
    FormOrderExchangeComponent
  ]
})
export class FormOrderExchangeModule { }
